module.exports = __webpack_public_path__ + "static/media/results_btn.b9c4a036.svg";